<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card :collapse-action="true" :title="`${localizedProperties.length} General Propert${localizedProperties.length === 1 ? 'y' : 'ies'} (${language.name})`">

      <vs-collapse accordion type="border" class="mb-2">

        <vs-collapse-item
          v-for="property in localizedProperties"
          :key="property.id">
          <div slot="header">
            {{property.title}} ({{ property.language.name }})
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input
                :label-placeholder="`Title (${property.language.name})`"
                v-model="property.title"
                class="w-full"
              />
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-textarea
                :label="`Body (${property.language.name})`"
                v-model="property.body"
                class="w-full"
              />
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-3/4 w-full mb-2">
              <div class="vx-row">
                <div class="vx-col w-1/2 mb-2">
                  <vs-button v-if="isModified" class="mx-1" @click="saveModifiedProperties">Save Changes</vs-button>
                </div>
                <div class="vx-col w-1/2 mb-2">
                  <vs-button v-if="isModified" type="border" color="warning" @click="revert" class="mx-1">Cancel</vs-button>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/4 w-full mb-2">
              <vs-button class="ml-auto" color="danger" icon="delete_outline" type="gradient" @click="deleteProperty(property)"></vs-button>
            </div>
          </div>

        </vs-collapse-item>

      </vs-collapse>
      <vs-button class="ml-auto" color="primary" type="border" icon-after icon="post_add" @click="showAddPropertyDialog">New Property</vs-button>


      <vs-prompt
        @accept="createProperty"
        title="New Property"
        :active.sync="showNewPropertyDialog">
        <div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input
                :label-placeholder="`Title (${addProductPropertyModel.language.name})`"
                v-model="addProductPropertyModel.title"
                class="w-full"
              />
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-textarea
                :label="`Body (${addProductPropertyModel.language.name})`"
                v-model="addProductPropertyModel.body"
                class="w-full"
              />
            </div>
          </div>

        </div>
      </vs-prompt>

    </vx-card>



</template>

<script>
  import types from '@/models';
  import {productHelpers} from '@/models/helpers';
  import api from '@/http/api';

  export default {
    data() {
      return {
        showNewPropertyDialog: false,
        addProductPropertyModel: new types.ProductProperty(),
        helpers: productHelpers,
        originalProperties: [new types.ProductProperty()],
        workingProperties: [new types.ProductProperty()],
      }
    },
    props: {
      product: {
        type: types.Product(),
        required: true,
        default: () => {
          return new types.Product()
        }
      },
      language: {
        type: types.Language,
        required: true,
      },
    },
    watch: {
      product: function (newVal, oldVal) {
        if (JSON.stringify(newVal.properties) === JSON.stringify(oldVal.properties)) return;
        this.originalProperties = JSON.parse(JSON.stringify(newVal.properties));
        this.workingProperties = JSON.parse(JSON.stringify(newVal.properties));
      },
      isModified: function (newVal, oldVal) {
        if (newVal === oldVal) return;
        this.$emit('unsavedChangesUpdate', newVal);
      }
    },
    computed: {
      isModified() {
        return JSON.stringify(this.originalProperties) !== JSON.stringify(this.workingProperties);
      },
      localizedProperties() {
        return this.workingProperties.filter((prop) => { return prop.language_id === this.language.language_id});
      }
    },
    methods: {
      revert() {
        this.workingProperties = JSON.parse(JSON.stringify(this.originalProperties));
      },
      showAddPropertyDialog() {
        this.addProductPropertyModel = new types.ProductProperty({
          product_id: this.product.product_id,
          language_id: this.language.language_id,
          language: this.language,
        });
        this.showNewPropertyDialog = true;
      },
      async saveModifiedProperties() {
        let success = false;
        for (let i=0; i<this.workingProperties.length; i++) {
          const originalJson = JSON.stringify(this.originalProperties[i]);
          const workingJson = JSON.stringify(this.workingProperties[i]);
          if (originalJson !== workingJson) {
            success = await this.updateProperty(JSON.parse(workingJson));
            if (!success) break;
          }
        }
        if (success) {
          this.originalProperties = JSON.parse(JSON.stringify(this.workingProperties));
          this.revert();
          this.$emit('productChanged');
        }
      },
      async createProperty() {
        const result = await api.createProductProperty(this.addProductPropertyModel);
        const success = result !== null;
        this.showNotification(success, `Property: ${result.title} (${result.id}) ${success ? 'CREATED' : ''}`);
        if (success) {
          this.originalProperties.push(result);
          this.revert();
          this.$emit('productChanged');
        }
      },
      async updateProperty(property) {
        const success = await api.updateProductProperty(property);
        this.showNotification(success, `Property: ${property.title} (${property.id}) ${success ? 'UPDATED' : ''}`);
        return success;
      },
      async deleteProperty(property) {
        const success = await api.deleteProductProperty(property);
        this.showNotification(success, `Property: ${property.title} (${property.id}) ${success ? 'DELETED' : ''}`);
        if (success) {
          this.originalProperties = this.originalProperties.filter((prop) => prop.id !== property.id);
          this.revert();
          this.$emit('productChanged');
        }
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
